<template>
  <div>
    <custom-loader v-if="loading" />
    <div v-for="(schedule, j) in groupedSchedules" v-else :key="j">
      <b-card no-body :class="j%2 === 1 ? 'mb-3' : 'bg-shade-2 mb-3'">
        <div class="row mt-3 p-2 custom-mbl-text-align">
          <div class="col-md-2">
            <div class="text-center">
              <div class="text-muted regular-14">
                <span>{{ moment(schedule.date, 'DD-MM-YYYY').format('MMM') }}</span>
              </div>
              <div class="bold-32">
                <span>
                  <span>{{ moment(schedule.date, 'DD-MM-YYYY').format('DD') }}</span>
                </span>
              </div>
              <div class="text-muted regular-14">
                <span>{{ moment(schedule.date, 'DD-MM-YYYY').format('YYYY') }}</span>
              </div>
              <div class="text-muted regular-14">
                <span>{{ moment(schedule.date, 'DD-MM-YYYY').format('dddd') }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-10">
            <div
              v-for="(item, k) in schedule.schedules" :key="k"
              class="row my-3 px-md-0 px-2"
              :class="schedule.schedules.length > 1 ? 'border-bottom' : ''"
            >
              <div class="col-md-10 col-10 mb-2">
                <div class="text-muted regular-14">
                  <i class="fas fa-clock mr-1" />
                  <span>{{ moment(item.from, 'YYYY-MM-DD HH:mm:ss').format('hh:mm a') }}</span>
                  <span> - </span>
                  <span>{{ moment(item.to, 'YYYY-MM-DD HH:mm:ss').format('hh:mm a') }}</span>
                </div>
                <div class="bold-16 mt-2 mb-2">
                  <span>
                    {{ item.title }}
                  </span>
                </div>
                <speaker :speakers="item.speakers" />
              </div>
              <div class="col-2">
                <div class="typo-color-blue">
                  <span>
                    <a v-b-toggle="'collapse' + mainIndex + j + k" @click.prevent>
                      <i v-b-tooltip.hover="'View More Details'" class="fas fa-eye cursor-pointer" />
                    </a>
                  </span>
                </div>
              </div>
              <b-collapse :id="'collapse' + mainIndex + j + k" accordion="schedule-accordion" class="col-12">
                <div class="mr-5 p-2">
                  <div class="row mb-3 mt-4">
                    <div class="col-md-4">
                      <span class="text-muted regular-16">Location</span>
                    </div>
                    <div class="col-md-8">
                      <div class="regular-16">{{ item.schedules_event_location || "--" }}</div>
                    </div>
                  </div>
                  <div class="row mb-3 mt-4">
                    <div class="col-md-4">
                      <span class="text-muted regular-16">Video</span>
                    </div>
                    <div class="col-md-8">
                      <i v-if="item.consent === false" v-b-tooltip.hover class="fas fa fa-thumbs-down" style="color:red" title="Speakers declined to publish materials" />
                      <i v-if="item.not_recorded === true && canEditCms" v-b-tooltip.hover class="fa fa-ban" style="color:red" title="No video was recorded" />
                      <i v-if="item.technical_difficulty === true && canEditCms" v-b-tooltip.hover class="fas fa-exclamation-triangle" style="color:red" title="Due to technical difficulty, no video is available" />

                      <span
                        v-if="item.videos.length === 0 && (canEditCms ? !(item.consent === false || item.technical_difficulty === true || item.not_recorded === true) : item.consent !== false)"
                        class="regular-16">--</span>
                      <span v-if="videoViewAccess(item)" class="ml-2">
                        <span v-if="item.videos.length > 0" class="regular-16 typo-color-blue mt-3">
                          <i v-if="(item.consent === false || item.technical_difficulty === true || item.not_recorded === true) && canEditCms" v-b-tooltip.hover.top="'SLMath Only'" class="fas fa-lock mr-1" style="color:black" />
                          <!-- <router-link :to="{ name: viewRouteName, params: { id: dataId, schedule_id: item.id } }">
                            <span v-b-tooltip.hover.top="item.video.length + ' Video/Audio File Available'">
                              <i class="fas fa-film"></i>
                              Watch Video
                            </span>
                          </router-link> -->
                          <div v-for="(video, index) in item.videos" :key="index">
                            <div class="d-flex flex-column h-100">
                              <b-card class="my-2 d-flex flex-column flex-grow-1 light-style">
                                <div v-if="video.playable">
                                  <div v-if="Array.isArray(video.playable.video_file_url)">
                                    <div v-if="video.playable.video_file_url && video.playable.video_file_url.length > 0" class="mt-2">
                                      <li v-for="(videoFile, j) in video.playable.video_file_url" :key="j">
                                        <a :href="videoFile.url">
                                          <i class="fa fa-play-circle" />
                                          <span>{{ videoFile.category }}</span>
                                          <span v-if="videoFile.size">({{ videoFile.size }})</span>
                                        </a>
                                      </li>
                                    </div>
                                    <div v-else>
                                      <span class="text-muted regular-14">No Video Available</span>
                                    </div>
                                  </div>
                                  <div v-else class="regular-16 typo-color-blue custom-html-text text-center mb-2">
                                    <VideoViewSection :video="video.playable" />
                                  </div>
                                </div>
                                <span class="regular-16 mb-4">{{ video.name }}</span>
                              </b-card>
                            </div>
                          </div>
                        </span>
                      </span>
                      <span v-else-if="item.videos.length > 0 && item.consent !== false" class="regular-16">---</span>
                    </div>
                  </div>
                  <div class="row mb-3 mt-4">
                    <div class="col-md-4">
                      <span class="text-muted regular-16">Abstract</span>
                    </div>
                    <div class="col-md-8">
                      <div class="regular-16 custom-html-text" v-html="item.abstract" />
                    </div>
                  </div>
                  <div class="row mb-3 mt-4">
                    <div class="col-md-4">
                      <span class="text-muted regular-16">Supplement</span>
                    </div>
                    <div class="col-md-8">
                      <div v-if="item.document.length > 0" class="regular-16 typo-color-blue">
                        <div v-for="(supplement, index) in item.document" :key="index">
                          <div v-for="(item, i) in supplement.document_file" :key="i">
                            <span class="regular-16 cursor-pointer">
                              <a :href="item.download_asset_path">
                                <i class="fas fa-file" />
                                {{ item.data_file_name }}
                              </a>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <span class="regular-16">--</span>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-start mb-3 mt-4">
                    <div class="ml-auto">
                      <router-link :to="{ name: viewRouteName, params: { id: dataId, schedule_id: item.id}}">
                        <span v-b-tooltip.hover.top="'Show Detail'" class="typo-color-black">
                          <i class="fa fa-info-circle typo-color-blue" />
                          Show Detail
                        </span>
                      </router-link>
                      <a
                        v-if="canEditCms"
                        :href="fetchLegacyUrl(`/${editBaseUrl}/${$route.params.id}/schedules/${item.id}/edit`)"
                      >
                        <span v-b-tooltip.hover.top="'Edit'" class="typo-color-black">
                          <i class="fas fa-edit custom-fa-edit-color ml-2" />
                          Edit
                        </span>
                      </a>
                      <span v-if="canEditCms" v-b-tooltip.hover.top="'Delete'" class="cursor-pointer" @click="removeSchedule(item.id, j)">
                        <i class="fas fa-trash-alt ml-2 custom-fa-delete-color" />
                        Delete
                      </span>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import mixin from "@/utils/mixin.js"
import Speaker from "@/components/CommonPages/Speaker.vue"
import { mapGetters } from "vuex"
import CustomLoader from "@/components/CommonPages/CustomLoader.vue"
import VideoViewSection from "@/components/CommonPages/VideoViewSection.vue"

export default {
	name: "ScheduleAndNotes",
	components: { Speaker, CustomLoader, VideoViewSection },
	mixins: [mixin],
	props: ["mainIndex", "groupedSchedules", "dataId", "editBaseUrl", "viewRouteName"],
	data() {
		return {
			loading: false,
		}
	},
	computed: {
		...mapGetters(["canEditCms"]),
	},
	methods: {
		removeSchedule(id, index) {
			if (confirm("Do you really want to remove this schedule?")) {
				this.loading = true
				this.$http.delete(`${process.env.VUE_APP_API_URL}/workshop_schedules/${id}`).then((res) => {
					if (res === undefined) {
						//this.$toasted.global.error("Action has been failed.");
					} else if (res.data.error !== undefined) {
						this.$toasted.global.error(res.data.error)
					} else {
						this.$toasted.global.success("Removed Successfully")
						const indexId = this.groupedSchedules[index].schedules.findIndex((o) => o.id === id)
						if (indexId !== -1) this.groupedSchedules[index].schedules.splice(indexId, 1)
						if (this.groupedSchedules[index].schedules.length === 0) {
							this.groupedSchedules.splice(index, 1)
						}
						this.loading = false
					}
				})
			}
		},
	},
}
</script>
